// extracted by mini-css-extract-plugin
module.exports = {"text-area-box":"__7l7s8Qq5","text-area-input":"zhRfTPOB"};